import { PulseSendTestResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type PulseSendTestResponseInput = z.input<typeof PulseSendTestResponseSchema>;
export type PulseSendTestResponseOutput = z.output<typeof PulseSendTestResponseSchema>;

export function serializePulseSendTestResponse(payload: PulseSendTestResponseInput): PulseSendTestResponseOutput {
  return PulseSendTestResponseSchema.parse(payload);
}
